import React from "react";
import { Box, Container, Typography } from "@mui/material";

export default function FooterSection() {
  return (
    <Box
      sx={{
        backgroundColor: "#1f2937",
        py: 6,
        color: "white",
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <Typography variant="body2" sx={{ color: "#9ca3af" }}>
          © 2025 Computerized AI. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
